import { render, staticRenderFns } from "./Dgmobile.vue?vue&type=template&id=73409556&scoped=true&"
import script from "./Dgmobile.vue?vue&type=script&lang=js&"
export * from "./Dgmobile.vue?vue&type=script&lang=js&"
import style0 from "./Dgmobile.vue?vue&type=style&index=0&id=73409556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73409556",
  null
  
)

export default component.exports